export const timeFormat = {
  yDateAndTimeAMPM: 'YYYY/MM/DD hh:mm A',
  dateAndTimeAMPM: 'MM/DD/YYYY hh:mm A',
  yDateAndTime: 'YYYY/MM/DD HH:mm:ss',
  dateAndTime: 'MM/DD/YYYY HH:mm:ss',
  dateAndTimeToMinute: 'YYYY/MM/DD HH:mm',
  dateAndTimeUTC: 'YYYY/MM/DD HH:mm UTC Z',
  date: 'MM/DD/YYYY',
  yDate: 'YYYY/MM/DD',
  yDateLower: 'yyyy/mm/dd',
  timeToMinute: 'HH:mm',
  timeToSecond: 'HH:mm:ss',
  enUsDateTime: 'MM-DD-YYYY',
  frFRDateTime: 'DD-MM-YYYY',
  jaJPDateTime: 'YYYY-MM-DD',
  connectivityDateAndTimeFormat: 'MMM D(HH:mm)',
  eventLogDateFormat: 'MMM DD, YYYY',
  csvDownloadFormat: 'YYYYMMDD-HHmm',
  dateMonthName: 'DD. MMM',
  yearAndMonthFormat: 'MMM YYYY',
  dpickerFormat: 'dd mmmm yyyy',
  singleDate: 'D',
  monthEnglish: 'MMM',
  singleYear: 'YYYY',
};
